import { useState } from "react";
import emailjs from "emailjs-com";

export default function Contact({ bgColor }) {
  const [errors, setErrors] = useState({});
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  const successMessage =
    "Gracias por tu mensaje. Nos pondremos en contacto a la brevedad.";
    
  const handleValidation = (e, values) => {
    e.preventDefault();
    const form = e.target;
    const newErrors = {};

    const inputs = form.querySelectorAll("input, textarea");
    inputs.forEach((input) => {
      if (!input.validity.valid) {
        switch (input.type) {
          case "email":
            newErrors[input.name] = "Ingresa un correo electrónico válido.";
            break;
          default:
            newErrors[input.name] = "Campo requerido.";
        }
      }
    });

    console.log("form", form);
    console.log("values", values);
    if (Object.keys(newErrors).length === 0) {
      // Form is valid, you can submit it here or do something else
      sendEmail(values);
    } else {
      setErrors(newErrors);
    }
  };

  const sendEmail = (values) => {
    console.log("values", values);

    const formData = {
      to_name: values.name,
      from_name: values.email,
      reply_to: values.phone,
      message: {
        colegio: values.company,
        message: values.message,
        contrato: values.contrato,
      },
    };
    emailjs
      .send(
        "service_8cvn268",
        "template_8zznr0a",
        formData,
        "FZJHOdNZ0PGs1dfsm",
        {
          publicKey: "FZJHOdNZ0PGs1dfsm",
        }
      )
      .then(
        (result) => {
          console.log(result.text);
          setShowSuccessMessage(true);
          // form.reset();
        },
        (error) => {
          setShowSuccessMessage(false);
          console.log(error.text);
        }
      );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    const values = {
      name: form.name.value,
      email: form.email.value,
      phone: form.phone.value,
      company: form.company.value,
      message: form.message.value,
      contrato: form.contrato.value,
    };
    handleValidation(e, values);
  };

  return (
    <>
      <section
        id="contact"
        className={`contact-us ptb-100 ${bgColor ? "gray-light-bg" : ""}`}
      >
        <div className="container">
          {showSuccessMessage && (
            <div alignItems="center" justifyContent="center" padding="20px">
              <p className="text-success" style={{ fontSize: "2rem" }}>
                {successMessage}
              </p>
            </div>
          )}
          {!showSuccessMessage && (
            <div className="row">
              <div className="col-12 pb-3 message-box d-none">
                <div className="alert alert-danger"></div>
              </div>
              <div className="col-md-5">
                <div className="section-heading">
                  <h2>Dejanos tu consulta</h2>
                  <p>
                    Si ya sos pasajero, escribinos y te responderemos lo más
                    rápido posible.
                  </p>
                </div>
                <div className="footer-address">
                  <h6>
                    <strong>Oficina Central </strong>
                  </h6>
                  <p>TUCUMAN 612, PISO 6, C.A.B.A. (C1049AAN)</p>
                  <ul>
                    <li>Tel:
                      <a href="https://wa.me/+5491126680675" class="contact__subtitle"> +54 (911) 2668-0675</a>
                    </li>
                    <li>
                      <span>
                        Email :
                        <a href="mailto:info@upgradeturismo.com.ar">
                          info@upgradeturismo.com.ar
                        </a>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-7">
                <form
                  action="#"
                  method="POST"
                  id="contactForm"
                  className="contact-us-form"
                  noValidate
                  onSubmit={handleSubmit}
                >
                  <h5>Responderemos rápido</h5>
                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          name="name"
                          id="name"
                          placeholder="Ingresa nombre completo del pasajero"
                          required
                        />
                        {errors.name && (
                          <p className="text-danger">{errors.name}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <input
                          type="email"
                          className="form-control"
                          name="email"
                          id="email"
                          placeholder="Ingresa email"
                          required
                        />
                        {errors.email && (
                          <p className="text-danger">{errors.email}</p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <input
                          type="text"
                          name="phone"
                          defaultValue=""
                          className="form-control"
                          id="phone"
                          placeholder="Tu teléfono o celular"
                          required
                        />
                        {errors.phone && (
                          <p className="text-danger">{errors.phone}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <input
                          type="text"
                          name="company"
                          defaultValue=""
                          size="40"
                          className="form-control"
                          id="company"
                          placeholder="Nombre del colegio"
                          required
                        />
                        {errors.company && (
                          <p className="text-danger">{errors.company}</p>
                        )}
                      </div>
                    </div>
                    <div className="col-sm-6 col-12">
                      <div className="form-group">
                        <input
                          type="text"
                          name="contrato"
                          defaultValue=""
                          size="40"
                          className="form-control"
                          id="contrato"
                          placeholder="Contrato"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <div className="form-group">
                        <textarea
                          name="message"
                          id="message"
                          className="form-control"
                          rows="7"
                          cols="25"
                          placeholder="Mensaje"
                          required
                        ></textarea>
                        {errors.message && (
                          <p className="text-danger">{errors.message}</p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12 mt-3">
                      <button
                        type="submit"
                        className="btn solid-btn"
                        id="btnContactUs"
                      >
                        Enviar mensaje
                      </button>
                    </div>
                  </div>
                </form>
                <p className="form-message"></p>
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
}
